import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import { appAuthContext } from 'context/AuthContext';
import { UserData } from 'context/AuthContext/AuthContext.types';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';
import { configuratorContext } from '../../context/ConfiguratorContext';
import {
  ConfiguratorAZs,
  ConfiguratorData,
} from '../../context/ConfiguratorContext/ConfiguratorContext.types';
import getConfigurationBanner from '../../components/Header/api/getConfigurationBanner';

type AuthControllerType = {
  children: React.ReactNode;
  userData: UserData | null;
};

const { publicRuntimeConfig } = getConfig();
const { OTVETY_GPT_WIDGET, SUPPORT_WIDGET_URL } = publicRuntimeConfig;

const AuthController: React.FC<AuthControllerType> = ({ children, userData }) => {
  const [user, setUser] = useState(userData);
  const [banners, setBanners] = useState<null | ConfiguratorData>(null);
  const [azFromConfigurator, setAzFromConfigurator] = useState<ConfiguratorAZs | null>(
    null,
  );

  // отправка статистики по визитам
  const sendVisitsStats = async () => {
    const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN');
    if (!csrf_token) {
      await fetch('/otvety/api/check', {
        credentials: 'include',
      });
    }
  };

  const getConfiguratorData = async () => {
    const configuratorData = await getConfigurationBanner();

    setAzFromConfigurator({
      otvety_ai_toolkit: configuratorData?.otvety_ai_toolkit || null,
      otvety_auth_variant: configuratorData?.otvety_auth_variant || null,
      otvety_ai_widget: configuratorData?.otvety_ai_widget || null,
    });
    setBanners(configuratorData);
  };

  const isAiWidget =
    azFromConfigurator && azFromConfigurator?.otvety_ai_widget?.groupName === 'target';

  useEffect(() => {
    sendVisitsStats();
    getConfiguratorData();
  }, [user]);

  return (
    <configuratorContext.Provider
      value={{ banners, setBanners, azFromConfigurator, setAzFromConfigurator }}
    >
      <appAuthContext.Provider value={{ user, setUser }}>
        {children}
        {!isAiWidget && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<esi:include src="${SUPPORT_WIDGET_URL}" />`,
            }}
          />
        )}
        {isAiWidget && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<esi:include src="${OTVETY_GPT_WIDGET}" />`,
            }}
          />
        )}
      </appAuthContext.Provider>
    </configuratorContext.Provider>
  );
};

export default AuthController;
